<div class="uploaded-file-container">
  <div class="uploaded-file-base">
    <div class="uploaded-file-icon">
      <img src="{{ iconPath }}" />
    </div>
    <div class="uploaded-file-text-area">
      <div class="uploaded-file-text-file-name">{{ fileName }}</div>
      <div class="uploaded-file-text-file-type">{{ fileType }}</div>
    </div>
    <div *ngIf="canDisplayMenu">
      <button mat-button [matMenuTriggerFor]="menu">
        <mat-icon class="uploaded-file-more-vert">more_vert</mat-icon>
      </button> 
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="downloadAttachment()">Download</button>
        <button mat-menu-item (click)="removeAttachment()">Remove</button>
      </mat-menu>
    </div>
  </div>
</div>